// extracted by mini-css-extract-plugin
module.exports = {"root":"GsiTrendChart_root__DO2DQ"};